var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "copy_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.172.428H.142v17.143h15.03V.428Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.735 17.571H9.57a2.59 2.59 0 0 0 2.56-2.254h.446a2.595 2.595 0 0 0 2.593-2.593V3.021A2.59 2.59 0 0 0 12.58.428H5.74A2.598 2.598 0 0 0 3.15 3.021v.413h-.414A2.598 2.598 0 0 0 .143 6.027v8.947a2.599 2.599 0 0 0 2.592 2.597Zm1.917-14.55c0-.601.488-1.09 1.09-1.09h6.833c.601 0 1.09.489 1.09 1.09v9.699a1.09 1.09 0 0 1-1.09 1.09h-.409V6.026a2.595 2.595 0 0 0-2.592-2.593H4.652v-.413ZM1.646 6.027c0-.601.488-1.09 1.09-1.09h6.833c.601 0 1.09.489 1.09 1.09v8.947a1.09 1.09 0 0 1-1.09 1.09H2.735a1.083 1.083 0 0 1-1.09-1.085V6.027Z",
    fill: "#606060"
  }))));
};
export default SvgCopy;